$(document).ready(function(){
  $(".menu-btn").click(function(){
  	var menuHandle = $(this).data("handle");
    var menuHeading = $(this).data("heading");
    $(".tab-content").scrollTop(0)
    $(".menu-btn").each(function(){
    	$(this).removeClass("active-btn");
    });
    $(".tab-content").each(function(){
    	$(this).removeClass("tab-content-active");
    });
    
    $(this).addClass("active-btn");
    $(".pageTitle").html(menuHeading);
    $("#"+menuHandle).addClass("tab-content-active");
  });

  

  
});
$(document).ready(function(){
    $(this).scrollTop(0);
  $(document.body).on('touchmove', onScroll);
});

function elementScrolled(elem)
{
  var docViewTop = $(window).scrollTop() || document.documentElement.scrollTop;
  var windowHeight = $(window).height() || document.body.scrollHeight;
  var docViewBottom = docViewTop + windowHeight;
  var elemTop = $(elem).offset().top;
  //return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
  if ((elemTop <= docViewBottom) && (elemTop >= docViewTop)) { 
    return "true";
  }
}
 $(window).scroll(function() {
   
   if(elementScrolled('#content-restaurant') == "true"){
     //console.log("restaurant active");
     $(".main-logo").show();
     $(".logo2").hide();
     $(".logo3").hide();
   }
   if(elementScrolled('#content-store') == "true"){
     //console.log("Store active");
     $(".main-logo").hide();
     $(".logo2").show();
     $(".logo3").hide();
   }

   if(elementScrolled('#link-homecoming-stories')  == "true"){
     //console.log("Homecoming active");
     $(".main-logo").hide();
     $(".logo2").hide();
     $(".logo3").show();
   }
   if($(window).scrollTop() === 0) {
     //console.log("Top Reached");
     $(".main-logo").show();
     $(".logo2").hide();
     $(".logo3").hide();
   } 
   if((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
     $(".main-logo").hide();
     $(".logo2").hide();
     $(".logo3").show();
   }
});


function onScroll(){
  if(elementScrolled('#content-restaurant') == "true"){
     //console.log("restaurant active");
     $(".main-logo").show();
     $(".logo2").hide();
     $(".logo3").hide();
   }
   if(elementScrolled('#content-store') == "true"){
     //console.log("Store active");
     $(".main-logo").hide();
     $(".logo2").show();
     $(".logo3").hide();
   }

   if(elementScrolled('#link-homecoming-stories')  == "true"){
     //console.log("Homecoming active");
     $(".main-logo").hide();
     $(".logo2").hide();
     $(".logo3").show();
   }
   if($(window).scrollTop() === 0) {
     //console.log("Top Reached");
     $(".main-logo").show();
     $(".logo2").hide();
     $(".logo3").hide();
   } 
   if((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
     $(".main-logo").hide();
     $(".logo2").hide();
     $(".logo3").show();
   }
}

const viewportHeight = () => {
  const doc = document.documentElement;
  const foodHeaderMenuContainer = document.querySelector(".site-header-sticky");
  console.log(foodHeaderMenuContainer.offsetHeight);
  doc.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  doc.style.setProperty("--food-menu-height", `${window.innerHeight - foodHeaderMenuContainer.offsetHeight}px`);
};
window.addEventListener("resize", viewportHeight);
viewportHeight();